module.exports = __webpack_public_path__ + "static/media/bg-item-4.6ac1c619.png";